import MDButton from "components/MDButton";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

// @mui material components
// import Icon from "@mui/material/Icon";

export default function CompoundDetailButtom(compound, setOpen, setSelectedCompoundForDetails) {
  const com = compound;

  const myClickHandler = () => {
    console.log(com);
    setOpen(true);
    setSelectedCompoundForDetails(com);
  };

  return (
    <MDButton
      fontSize="small"
      variant="gradient"
      value={com}
      color="white"
      iconOnly
      onClick={myClickHandler}
    >
      <SearchOutlinedIcon />
    </MDButton>
  );
}
